module.exports = __webpack_public_path__ + "static/media/edx-bootcamps-logo.4edb9ebe.jpg";